export default "__VITE_ASSET__CClUWrwT__"